import {Box, Button, Typography} from "@mui/material";
import {useState} from "react";
import QuestionModal from "pages/Faq/components/Banner/QuestionModal";

const Banner = () => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const onCloseModal = () => setOpenModal(false);
  const onOpenModal = () => setOpenModal(true);
  return (
    <>
      <Box sx={(theme) => ({
        px: 2,
        py: 3,
        borderRadius: 3,
        backgroundColor: 'grey.1000',
        boxShadow: '0px 4px 56.5px 0px rgba(0, 0, 0, 0.05)',
        [theme.breakpoints.up('md')]: {
          display: 'flex',
          justifyContent: 'space-between',
          px: 2.5,
          py: 4
        },
        [theme.breakpoints.up('xl')]: {
          p: 5,
        },
      })}>
        <Box sx={{
          mb: {xxs: 4, md: 0},
          mr: {md: 2},
          display: 'flex',
          flexDirection: 'column',
        }}>
          <Typography sx={(theme) => ({
            color: 'grey.200',
            mb: {xxs: 1.5},
            ...theme.typography.h4,
            [theme.breakpoints.up('sm')]: {
              ...theme.typography.h3,
            },
            [theme.breakpoints.up('xl')]: {
              ...theme.typography.h2,
            },
          })}>
            Приветствуем!
          </Typography>
          <Typography sx={(theme) => ({
            mb: {xxs: 2.5},
            ...theme.typography.h4,
            [theme.breakpoints.up('sm')]: {
              ...theme.typography.h3,
            },
            [theme.breakpoints.up('md')]: {
              flexGrow: 1,
            },
            [theme.breakpoints.up('xl')]: {
              ...theme.typography.h2,
            },
          })}>
            На&nbsp;этой странице мы&nbsp;собрали для вас&nbsp;ответы на&nbsp;часто встречающиеся вопросы
            о&nbsp;«Движении&nbsp;первых»
          </Typography>
          <Typography sx={(theme) => ({
            ...theme.typography.p2,
            [theme.breakpoints.up('sm')]: {
              ...theme.typography.p1,
            }
          })}>
            Выберите интересующую вас&nbsp;тему: возможно, у&nbsp;нас&nbsp;уже есть&nbsp;ответ на&nbsp;ваш&nbsp;вопрос.
          </Typography>
        </Box>
        <Box sx={(theme) => ({
          py: 4,
          px: 2.5,
          borderRadius: 3,
          backgroundColor: 'primary.main',
          display: 'flex',
          flexDirection: 'column',
          [theme.breakpoints.up('md')]: {
            minWidth: 252
          },
          [theme.breakpoints.up('xl')]: {
            p: 5
          },
        })}>
          <Typography variant={'h4'} sx={{textAlign: 'center', color: '#fff', mb: {xxs: 1.5}}}>
            Не&nbsp;нашли ответ
            на&nbsp;свой вопрос?
          </Typography>
          <Typography variant={'p1'} sx={(theme) => ({
            textAlign: 'center',
            color: '#fff',
            mb: {xxs: 3},
            [theme.breakpoints.up('md')]: {
              flexGrow: 1,
            }
          })}>
            Задай его&nbsp;и&nbsp;мы&nbsp;ответим тебе лично
          </Typography>
          <Button
            onClick={onOpenModal}
            sx={(theme) => ({
              backgroundColor: '#fff',
              color: 'black.100',
              px: 2.5,
              py: 1.2,
              fontFamily: '"Pragmatica Extended", Arial, sans-serif',
              fontSize: 14,
              fontWeight: 500,
              lineHeight: '150%'
            })}
          >
            Задать вопрос
          </Button>
        </Box>
      </Box>
      {openModal && (<QuestionModal open={openModal} onClose={onCloseModal} />)}
    </>
  )
}
export default Banner;
